import api from 'api'

export type GetAllAssessmentRequirementsParams = {
  maxLevel?: number
  positionTemplateId?: number
}

export type AssessmentRequirement = {
  positionTemplateId: number
  positionTemplateName: string
  workerRequirementId: number
  workerRequirementName: string
  level: number
}

/**
 * Fetches all assessment requirements optionally filtered by position template and max level.
 */
export async function getAllAssessmentRequirements(
  params: GetAllAssessmentRequirementsParams = {}
) {
  const response = await api.get<AssessmentRequirement[]>(
    '/admin/positions/assessment_levels',
    { params }
  )

  return response.data
}
